<template>
    <div v-if="showSidebar" class="sidebar shadow-1 md:border-right-1 md:shadow-none border-200 z-2 fixed bg-white bottom-0 md:left-0 md:w-5rem md:h-full md:pt-7 md:flex align-items-center flex-column ">

        <TabNavigation :items="filteredItems" />
    </div>
</template>

<script setup>
import TabNavigation from './TabNavigation.vue';
import { computed } from "vue";
import { useRoute } from 'vue-router';
import { useStore } from 'vuex'
const store = useStore()


const items = {
    administrador: [
        { label: 'Início', icon: 'pi pi-fw pi-home', to: '/administrador' },
        { label: 'Usuários', icon: 'pi pi-users', to: '/administrador/usuarios' },
        { label: 'Turmas', icon: 'pi pi-box', to: '/administrador/turmas' },
        { label: 'Cursos', icon: 'pi pi-book', to: '/administrador/cursos' },
        { label: 'Sair', icon: 'pi pi-sign-out', to: '/sair' }

    ],
    professor: [
        { label: 'Notas', icon: 'pi pi-chart-line', to: '/professor/turma/notas' },
        { label: 'Planos', icon: 'pi pi-box', to: '/professor/turma/planos' },
        { label: 'Lembretes', icon: 'pi pi-calendar-plus', to: '/professor/turma/lembretes' },
        { label: 'Notações', icon: 'pi pi-star', to: '/professor/turma/notacoes' },
        { label: 'Grupos', icon: 'pi pi-users', to: '/professor/turma/grupos' },
        {label: "Caderno", icon: "pi pi-bookmark", to: "/professor/turma/caderno"}

    ],
    estudante: [
        { label: 'Conteúdo', icon: 'pi pi-book', to: '/estudante/aula/conteudo' },
        { label: 'Grupos', icon: 'pi pi-users', to: '/estudante/aula/grupos' },
        { label: 'Avaliação', icon: 'pi pi-chart-line', to: '/estudante/aula/avaliacao' },
        { label: 'Caderno', icon: 'pi pi-bookmark', to: '/estudante/aula/caderno'}
    ]
}

const route = useRoute();

const showSidebar = computed(() => store.state.layout.showSidebar);

const filteredItems = computed(() => {
    const userType = route.path.split('/')[1]; // Pega o primeiro segmento da rota, como 'adm', 'professor', ou 'estudante'

    return items[userType] || []; // Retorna os itens correspondentes ou um array vazio se não houver correspondência
});


</script>

<style >



</style>